import React from 'react'
import './HospitalStats.css'
//import axios from 'axios'
import TotalHospitals from './TotalHospitals'
import StateHospital from './StateHospital'
const HospitalStats = () => {



    return (
        <div>
            <TotalHospitals/>
            <StateHospital/>
            
        </div>
    )
}

export default HospitalStats
